import {
  Portal as ReactNativeTeleportPortal,
  PortalHost as ReactNativeTeleportPortalHost,
} from "react-native-teleport";
import { createElement, type ComponentProps } from "react";
import { useResolveClassNames } from "@-/com.npmjs.uniwind";

export * from "react-native-teleport";

type PortalProps = Omit<ComponentProps<typeof ReactNativeTeleportPortal>, "style"> & {
  className?: string;
};

type PortalHostProps = Omit<ComponentProps<typeof ReactNativeTeleportPortalHost>, "style"> & {
  className?: string;
};

// Using `withUniwind` here results in a `CSSStyleDeclaration` error on web because
// `style` as an array is NOT supported in react-native-teleport's web implementation
export function Portal({ className = "", ...props }: PortalProps) {
  const classNameStyle = useResolveClassNames(className);

  return createElement(ReactNativeTeleportPortal, {
    ...props,
    style: classNameStyle,
  });
}

export function PortalHost({ className = "", ...props }: PortalHostProps) {
  const classNameStyle = useResolveClassNames(className);

  return createElement(ReactNativeTeleportPortalHost, {
    ...props,
    style: classNameStyle,
  });
}
